import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

// Import translation files
import enCommon from './locales/en/common.json';
import enHomepage from './locales/en/homepage.json';
import enHeader from './locales/en/header.json';
import enAbout from './locales/en/about.json';
import esCommon from './locales/es/common.json';
import esHomepage from './locales/es/homepage.json';
import esHeader from './locales/es/header.json';
import esAbout from './locales/es/about.json';

// Language resources
const resources = {
  en: {
    common: enCommon,
    homepage: enHomepage,
    header: enHeader,
    about: enAbout
  },
  es: {
    common: esCommon,
    homepage: esHomepage,
    header: esHeader,
    about: esAbout
  },
  fr: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  de: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  it: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  pt: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  ru: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  ja: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  ko: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  zh: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  hi: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  ar: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  tr: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  pl: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  nl: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  sv: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  da: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  no: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  fi: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  he: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  th: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  vi: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  uk: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  cs: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  sk: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  hu: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  ro: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  bg: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  hr: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  et: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  lv: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  lt: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  },
  sl: {
    common: {},
    homepage: {},
    header: {},
    about: {}
  }
};

// Supported languages configuration
export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'hi', name: 'हिंदी', flag: '🇮🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
  { code: 'he', name: 'עברית', flag: '🇮🇱' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'bg', name: 'Български', flag: '🇧🇬' },
  { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' },
  { code: 'et', name: 'Eesti', flag: '🇪🇪' },
  { code: 'lv', name: 'Latviešu', flag: '🇱🇻' },
  { code: 'lt', name: 'Lietuvių', flag: '🇱🇹' },
  { code: 'sl', name: 'Slovenščina', flag: '🇸🇮' }
];

// Initialize i18n
i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'homepage', 'header', 'about'],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      checkWhitelist: true
    },

    interpolation: {
      escapeValue: false // React already does escaping
    },

    react: {
      useSuspense: false
    },

    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;